<template>
	<div class="batch-import-task-page page-layout">
		<gc-header headerData="batchImportTask">
			<template #ops>
				<el-dropdown trigger="click" @command="handleShowTaskModal">
					<el-button type="primary">
						创建任务
						<i class="el-icon-arrow-down el-icon--right"></i>
					</el-button>
					<el-dropdown-menu slot="dropdown" style="min-width: 110px">
						<el-dropdown-item command="import" style="line-height: 36px">批量导入</el-dropdown-item>
						<el-dropdown-item command="update" style="line-height: 36px">批量更新</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</template>
		</gc-header>
		<div class="run-main">
			<div class="serach">
				<gc-advanced-filter
					ref="advancedFilter"
					v-model="filterParams"
					:fields="filterFields"
					@search="handleFilterSearch"
					@reset="handleFilterReset"
				/>
				<gc-column-setting
					storageKey="localcolumn-batch-import-task"
					:columns="columns"
					@update-column="data => (columns = data)"
				></gc-column-setting>
			</div>
			<div class="table-show" v-loading="loading">
				<gc-table
					border
					showPage
					:columns="columnList"
					:table-data="tableData"
					:current-page.sync="pagination.currentPage"
					:total="pagination.total"
					:pageSize="pagination.pageSize"
					gloabSortDisable
					@current-page-change="handleCurrentPageChange"
					@size-change="handlePageSizeChange"
				></gc-table>
			</div>
		</div>

		<!-- 任务创建弹窗 -->
		<TaskModal
			v-if="taskModalVisible"
			:deviceTypeOptions="deviceTypeOptions"
			:operateType="operateType"
			@close-modal="handleCloseModal"
		/>

		<!-- 取消任务弹窗 -->
		<CancelTaskModal v-if="cancelModelVisible" :taskId="currentTaskId" @close-modal="handleCloseModal" />
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import { apiGetBatchImportTaskList } from '@/apis/batchImportTask.api'
import { batchImportTaskStatusOptions } from '@/config/const'
import TaskModal from './components/TaskModal'
import CancelTaskModal from './components/CancelTaskModal'

export default {
	name: 'batchImportTask',
	components: { TaskModal, CancelTaskModal },
	data() {
		return {
			batchImportTaskStatusOptions,
			filterParams: {
				taskName: null,
				taskStatus: null,
				deviceTypeIdList: [],
			},
			columns: [
				{
					key: 'taskName',
					name: '任务名称',
					tooltip: true,
					dragDisable: true,
					disabledSelect: true,
					minWidth: 180,
					fixed: 'left',
				},
				{
					key: 'deviceTypeName',
					name: '设备类型',
					tooltip: true,
					minWidth: 200,
				},
				{
					key: 'optType',
					name: '操作类型',
					minWidth: 180,
					render: (h, row) => {
						const optTypeMap = {
							0: '新增设备',
							1: '新增并安装设备',
							2: '仅安装设备',
							3: '更新设备',
						}
						return h('span', null, optTypeMap[row.optType] || '--')
					},
				},
				{
					key: 'taskStatus',
					name: '任务状态',
					minWidth: 180,
					render: (h, row) => {
						const classMap = {
							0: 'dot-message',
							1: 'dot-message',
							2: 'dot-success',
							3: 'dot-error',
						}
						return h('span', { class: classMap[row.taskStatus] }, row.taskStatusName)
					},
				},
				{
					key: 'waitCount',
					name: '前方排队数',
				},
				{
					key: 'importCount',
					name: '导入总数',
				},
				{
					key: 'importWaitCount',
					name: '待执行数',
				},
				{
					key: 'importSuccessCount',
					name: '成功数',
				},
				{
					key: 'importFailCount',
					name: '失败数',
				},
				{
					key: 'createStaffName',
					name: '创建人',
				},
				{
					key: 'createTime',
					name: '创建时间',
					minWidth: 180,
					tooltip: true,
				},
				{
					key: 'oprate',
					name: '操作',
					sortDisable: true,
					width: 100,
					fixed: 'right',
					render: (h, row) => {
						return h('div', {}, [
							h(
								'el-button',
								{
									props: {
										type: 'text',
										size: 'medium',
									},
									on: {
										click: () => {
											this.$router.push({
												path: '/device/batch-import-task-details',
												query: {
													taskId: row.taskId,
												},
											})
										},
									},
								},
								'详情',
							),
							row.taskStatus === 0
								? h(
										'el-button',
										{
											style: { color: '#e5662e' },
											props: {
												type: 'text',
												size: 'medium',
											},
											on: {
												click: () => {
													this.currentTaskId = row.taskId
													this.cancelModelVisible = true
												},
											},
										},
										'取消',
								  )
								: null,
						])
					},
				},
			],
			pagination: {
				currentPage: 1,
				pageSize: 20,
				total: 0,
			},
			tableData: [],
			loading: false,
			deviceTypeOptions: [],
			taskModalVisible: false,
			cancelModelVisible: false,
			currentTaskId: null,
			operateType: '',
		}
	},
	created() {
		this.judgeNeedPickOrg().then(data => {
			if (data) {
				this.getTreeOptions()
				this.queryBatchImportTaskList()
				this.getDeviceTypeListOptions()
			}
		})
	},

	methods: {
		...mapActions({
			getDeviceTypeList: 'common/getDeviceTypeList',
			getTreeOptions: 'user/getTreeOptions',
			judgeNeedPickOrg: 'user/judgeNeedPickOrg',
		}),

		// 高级筛选查询
		handleFilterSearch() {
			this.pagination.currentPage = 1
			this.queryBatchImportTaskList()
		},

		// 高级筛选重置
		handleFilterReset() {
			this.pagination.currentPage = 1
			this.queryBatchImportTaskList()
		},

		async queryBatchImportTaskList() {
			this.loading = true
			const searchParams = {
				...this.filterParams,
				current: this.pagination.currentPage,
				size: this.pagination.pageSize,
			}
			try {
				const { records = [], total } = await apiGetBatchImportTaskList(searchParams)
				this.tableData = records
				this.pagination.total = total
			} finally {
				this.loading = false
			}
		},

		async getDeviceTypeListOptions() {
			const data = await this.getDeviceTypeList()
			this.deviceTypeOptions = data.filter(item => item.isSupportBatchImport)
		},

		handleCurrentPageChange(current) {
			this.pagination.currentPage = current
			this.queryBatchImportTaskList()
		},

		handlePageSizeChange(size) {
			this.pagination.currentPage = 1
			this.pagination.pageSize = size
			this.queryBatchImportTaskList()
		},

		handleCloseModal(refresh) {
			this.taskModalVisible = false
			this.cancelModelVisible = false
			if (refresh) {
				this.handleFilterSearch()
			}
		},

		handleShowTaskModal(command) {
			this.operateType = command
			this.taskModalVisible = true
		},
	},

	computed: {
		filterFields() {
			return [
				{
					prop: 'taskName',
					label: '任务名称',
					type: 'input',
					width: '320px',
				},
				{
					prop: 'taskStatus',
					label: '任务状态',
					type: 'select',
					props: {
						searchOption: this.batchImportTaskStatusOptions,
						needAllForSearch: true,
					},
				},
				{
					prop: 'deviceTypeIdList',
					label: '设备类型',
					type: 'select',
					props: {
						searchOption: this.deviceTypeOptions,
						filterable: true,
						multiple: true,
						needAllForSearch: true,
					},
				},
			]
		},

		columnList() {
			return this.columns.filter(o => o.selected)
		},

		tenantId() {
			return this.$store.getters.userInfo.tenantId || null
		},
	},
}
</script>
<style lang="scss" scoped>
@import '../../run-manage/runLayout.scss';
</style>
